$(document).ready(function () {
  const $carouselItems = $('.carousel-item2');
  const $tabSlider = $('#tab-slider2');

  // const originalBackground = getComputedStyle($tabSlider[0]).getPropertyValue('--themed-background').trim();
  // const originalForeground = getComputedStyle($tabSlider[0]).getPropertyValue('--themed-foreground').trim();

   if ($tabSlider.length === 0) return;

  const el = $tabSlider.get(0);
  const cs = window.getComputedStyle(el);
  const originalBackground = cs.getPropertyValue('--themed-background').trim();
  const originalForeground = cs.getPropertyValue('--themed-foreground').trim();

  const projectThemes = [
    { background: '#2D2D2D', foreground: '#0F0F0F' },
    { background: '#3A2E39', foreground: '#F4EBE8' },
    { background: '#2C3E50', foreground: '#ECF0F1' }
  ];

  $('.project-item2').on('mouseenter', function () {
    const index = $(this).data('index');

    // Fade in the corresponding image
    $carouselItems.removeClass('active');
    $carouselItems.eq(index).addClass('active');

    // Theme change
    if (index < projectThemes.length) {
      $tabSlider.css('--themed-background', projectThemes[index].background);
      $tabSlider.css('--themed-foreground', projectThemes[index].foreground);
    }
  });

  $('.project-list2').on('mouseleave', function () {
    $carouselItems.removeClass('active');
    $carouselItems.eq(0).addClass('active'); // Reset to first

    $tabSlider.css('--themed-background', originalBackground);
    $tabSlider.css('--themed-foreground', originalForeground);
  });
});
